<!--
 * @Descripttion:
 * @Author: zcy
 * @Date: 2022-01-07 10:16:16
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 16:01:54
-->
<template>
  <!-- 育苗结转成本统计表-中层-育苗-成本概览-明细列表 -->
  <div class="page-list old-page-list">
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select @change="baseIdChange" v-model="param.params.baseId" filterable placeholder="请选择养殖场">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in baseList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖区域&nbsp;:</label>
          <el-select @change="groupIdChange" v-model="param.params.groupId" filterable placeholder="请选择养殖区域">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in groupList" :label="item.groupName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖单元&nbsp;:</label>
          <el-select v-model="param.params.boxId" filterable placeholder="请选择养殖单元">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in boxList" :label="item.boxCode" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖造次&nbsp;:</label>
          <el-select v-model="param.params.periodId" filterable placeholder="请选择养殖造次">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in periodList" :label="item.year" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" filterable placeholder="请选择养殖品种">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in breedTypeList" :label="item.breedTypeName"
              :value="item.breedTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" filterable placeholder="请选择养殖品种">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in breedList" :label="item.breedName" :value="item.id"></el-option>
          </el-select>
        </div>
        <!-- <div class="page-search-item">
          <label>养殖阶段&nbsp;:</label>
          <el-select
            v-model="param.params.stageId"
            filterable
            placeholder="请选择养殖阶段"
          >
            <el-option label="无批次" value=""></el-option>
            <el-option
                  :key="item.id"
                  v-for="item in breedingStages"
                  :label="item.value"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div> -->
        <div class="page-search-item">
          <label>操作类型&nbsp;:</label>
          <el-select v-model="param.params.operationTypeId" filterable placeholder="请选择操作类型">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in typeList" :label="item.operationType"
              :value="item.operationTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-date">
          <div class="page-search-item date-selection-box">
            <span @click="param.params.type = 'Y'" :class="[param.params.type == 'Y' ? 'active-date' : '']">年</span>
            <span @click="param.params.type = 'M'" :class="[param.params.type == 'M' ? 'active-date' : '']">月</span>
            <span @click="param.params.type = 'D'" :class="[param.params.type == 'D' ? 'active-date' : '']">日</span>
          </div>
        </div>
        <div class="page-search-item">
          <label>操作日期&nbsp;:</label>
          <!-- 日 -->
          <el-date-picker :picker-options="pickerOptions" v-if="param.params.type === 'D'" @change="dateSelectChange"
            key="date" value-format="yyyy-MM-dd" v-model="date" type="daterange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <!-- 月 -->
          <el-date-picker :picker-options="pickerOptions" v-if="param.params.type === 'M'" @change="dateSelectChange"
            key="month" value-format="yyyy-MM" v-model="date" type="monthrange" range-separator="~"
            start-placeholder="开始月份" end-placeholder="结束月份"></el-date-picker>
          <!-- 年 -->
          <el-date-picker :picker-options="pickerOptions" v-if="param.params.type === 'Y'" @change="dateSelectChange"
            key="year" value-format="yyyy" v-model="param.params.year" type="year"></el-date-picker>
        </div>
        <div class="page-search-item">
          <label>查询合计&nbsp;:</label>
          <el-checkbox v-model="param.params.total" :value="false"></el-checkbox>
        </div>
      </div>
      <div class="page-search-btn">
        <div @click="search" class="search-btn">查询</div>
        <div @click="reSet" class="reset-btn">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span>
            <i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span>
            <i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>养成结转成本统计表</div>
        <div></div>
        <div></div>
        <div style="cursor: unset">
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport" style="cursor: pointer">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出
          </span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="养殖区域"></el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="boxName" label="塘口/箱号"></el-table-column>
        <el-table-column :fixed="fixedColumnList[6].fixed" :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''"
          prop="operationDate" label="操作日期"></el-table-column>
        <el-table-column :fixed="fixedColumnList[7].fixed" :class-name="fixedColumnList[7].selected ? 'cellSelected' : ''"
          prop="operationType" label="操作类型"></el-table-column>
        <el-table-column label="变动成本">
          <el-table-column prop="putDate" label="投苗日期"></el-table-column>
          <el-table-column prop="putNumberSeed" label="投苗数量(尾)"></el-table-column>
          <el-table-column prop="putMoneySeed" label="苗成本(元)"></el-table-column>
          <el-table-column prop="putNumberFodd" :label="'饲料数量(' + fodderKgToJin + ')'"></el-table-column>
          <el-table-column prop="putMoneyFodd" label="饲料金额(元)"></el-table-column>
          <el-table-column prop="putMoneyDrug" label="动保"></el-table-column>
          <el-table-column prop="consumablesCost" label="低值易耗品"></el-table-column>
          <el-table-column prop="electricCost" label="电费"></el-table-column>
          <el-table-column prop="artificialCost" label="人工成本"></el-table-column>
          <el-table-column prop="netCost" label="网费"></el-table-column>
          <el-table-column prop="deprecitCost" label="折旧与摊销"></el-table-column>
          <el-table-column prop="otherFee" label="其他公摊费"></el-table-column>
        </el-table-column>
        <el-table-column label="定额费用">
          <el-table-column prop="oldFee" label="网箱折旧(元)"></el-table-column>
          <el-table-column prop="manageFee" label="网箱管理费(元)"></el-table-column>
          <el-table-column prop="seaAreaFee" label="海域费(元)"></el-table-column>
          <el-table-column prop="rentPondFee" label="塘租"></el-table-column>
        </el-table-column>
        <el-table-column prop="total" label="成本合计"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize" :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>

<script>
// 获取ym-存塘概览已经调通的集连接口逻辑
import {
  getBaseListsByUser,
  queryBaseGroupList,
  getOrgInfoByOrgId,
  getBreedCategory,
  listDataPermissionBoxData,
  getBreedTypeList,
  getSeedlingCostOfoperationType,
  getCostRecordsListByPages,
  getDictionarysByTypeYc,
  getBatchListYc,
} from "../yc-overage/yc-overage-services";
import MyPagination from "@/components/pc/my-pagination.vue";
import Page from "@/utils/methods/page";
import { listParamStatus } from "@/api/general.js";
export default {
  components: { MyPagination },
  data() {
    return {
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime();
        },
      },
      modelValue: "",
      date: [],
      // 折现图显示与否
      ehcartShow: true,
      // 折现图类别切换
      ehcartActivity: true,
      PageDisplay: true,
      tableTitle: "",
      tableDate: Page.getCurrentYear(),
      dateSelectNum: "1",
      value: "",
      tableData: [],
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxName",
          fixed: false,
          selected: false
        },
        {
          prop: "operationDate",
          fixed: false,
          selected: false
        },
        {
          prop: "operationType",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1,
        pageSize: 13,
        totalCount: 0,
        orderBy: "desc",
        orderByName: "periodId",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          breedId: "",
          type: "Y", // Y表示年,M表示按月查询,D表示近日查询
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : Page.getCurrentYear(), // 如果type为Y则year不能为空,如果type不为Y year一定要为null
          startDate: "",
          endDate: "",
          total: false,
          operationTypeId: "", //操作类型
          breedTypeId: "", // 养殖品类
          periodId: "", // 育苗批次
          breedTypeClass: "fish", // fish ：养成 egg：育苗
        },
      },
      baseList: [], //养殖场data
      groupList: [], //养殖区域data
      breedList: [], //养殖品种数据
      boxList: [], //品种下拉数据
      periodList: [], //养殖造次data
      breedTypeList: [], //养殖品类data
      typeList: [], //操作类型data
      breedingStages: [], //养殖阶段data
      fodderKgToJin: '公斤'   // 是否把公斤转换成斤
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    Page.pagesTableFixed();
    // 获取养殖场
    this.getBaseList();
  },
  // 数据监听
  watch: {
    date: function (newVal, oldVal) {
      if (newVal.length) {
        this.param.params.startDate = newVal[0];
        this.param.params.endDate = newVal[1];
      } else {
        this.param.params.startDate = "";
        this.param.params.endDate = "";
      }
    },
    "param.params.type": function (newVal, oldVal) {
      if (newVal === "Y") {
        this.date = [];
        this.param.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : Page.getCurrentYear();
        return;
      }
      if (newVal === "M") {
        this.date = [];
        this.param.params.year = null;
      }
      if (newVal === "D") {
        this.date = [];
        this.param.params.year = null;
      }
    },
  },
  methods: {
    dateSelectChange(time) {
      if (time == null) {
        this.date = [];
      }
    },
    // 获取养殖造次列表(每次更新养殖场重新获取)
    getPeriodList(orgId) {
      getBatchListYc(orgId)
        .then((res) => {
          const arr = res.data.map((item) => ({
            id: item.id,
            year: item.year + item.makeValue,
          }));
          this.periodList = arr;
        })
        .catch((err) => this.$message.error(err));
    },
    /**
     * 获取养殖阶段列表
     */
    getBreedingStage() {
      getDictionarysByTypeYc("breedingStage")
        .then((res) => {
          this.breedingStages = res.data;
        })
        .catch((err) => this.$message.erorr(err));
    },
    // 获取养殖场下所有操作类型(每次更新养殖场重新获取)
    getOperationTypes(baseId) {
      getSeedlingCostOfoperationType(baseId)
        .then((res) => {
          this.typeList = res.data;
          // console.log(res, "获取所有可用操作类型");
        })
        .catch((err) => this.$message.error(err));
    },
    // 获取养殖场下所有养殖品类(每次更新养殖场重新获取)
    getBreedTypeList(baseId) {
      getBreedTypeList(baseId)
        .then((res) => {
          this.breedTypeList = res.data;
          // console.log(res, "获取所有可用养殖品类");
        })
        .catch((err) => this.$message.error(err));
    },
    // 监听养殖区域改变事件重新获取养殖单元
    groupIdChange(groupId) {
      this.boxList = [];
      this.param.params.boxId = "";
      this.getPermissionList(groupId);
    },
    // 监听养殖场改变事件重新获取养殖区域和养殖品种
    baseIdChange(event) {
      this.baseList.filter((item) => {
        if (event === item.id) {
          console.log(item);
          this.param.params.orgId = item.orgId;
        }
      });
      // 养殖场改变初始化数据
      this.param.params.groupId = "";
      this.groupList = [];
      this.param.params.breedId = "";
      this.breedList = [];
      this.param.params.boxId = "";
      this.boxList = [];
      this.param.params.stageId = "";
      this.breedingStages = [];
      this.param.params.breedTypeId = "";
      this.breedTypeList = [];
      this.param.params.breedTypeId = "";
      this.typeList = [];
      this.param.params.periodId = "";
      this.periodList = [];
      // 重新获取养殖区域
      this.getBaseGroupList(this.param.params.baseId);
      // 重新获取养殖品种
      this.getOneOrgId(this.param.params.orgId);
      // 重新获取养殖造次
      this.getPeriodList(this.param.params.orgId);
      // 重新获取养殖品类
      this.getBreedTypeList(this.param.params.baseId);
      // 重新获取养殖阶段
      this.getBreedingStage(this.param.params.baseId);
      // 重新获取操作类型
      this.getOperationTypes(this.param.params.baseId);
      // 重新获取饲料公斤转换斤的判断
      this.getFodderMeasureUnit(this.param.params.orgId);
    },
    // 获取权限下所有养殖场
    getBaseList() {
      getBaseListsByUser()
        .then((res) => {
          this.baseList = res.data;
          if (this.baseList.length) {
            this.param.params.orgId = this.baseList[0].orgId;
            this.param.params.baseId = this.baseList[0].id;
            // 获取养殖区域
            this.getBaseGroupList(this.param.params.baseId);
            // 获取养殖品种
            this.getOneOrgId(this.param.params.orgId);
            // 获取养殖造次
            this.getPeriodList(this.param.params.orgId);
            // 获取养殖品类
            this.getBreedTypeList(this.param.params.baseId);
            // 获取操作类型
            this.getOperationTypes(this.param.params.baseId);
            // 获取养殖阶段
            this.getBreedingStage(this.param.params.baseId);
            // 获取饲料公斤转换斤的判断
            this.getFodderMeasureUnit(this.param.params.orgId);
            this.initPage(this.param);
          }
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖场下所有养殖区域
    getBaseGroupList(baseId) {
      queryBaseGroupList(baseId)
        .then((res) => {
          this.groupList = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖区域下所有养殖单元
    getPermissionList(groupId) {
      listDataPermissionBoxData(groupId)
        .then((res) => {
          this.boxList = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 根据机构id获取顶级机构id
    getOneOrgId(orgId) {
      getOrgInfoByOrgId(orgId)
        .then((res) => {
          // 根据顶级机构id获取到顶级机构下所有养殖品种
          getBreedCategory(res.data.id).then((res) => {
            this.breedList = res.data;
          });
        })
        .catch((err) => console.log(err));
    },
    // pageSize改变
    handleSizeChange(pageSize) {
      this.param.currPage = 1;
      this.param.pageSize = pageSize;
      this.initPage(this.param);
    },
    // page改变
    handleCurrentChange(page) {
      this.param.currPage = page;
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    reSet() {
      this.param = {
        currPage: 1,
        pageSize: 13,
        totalCount: 0,
        orderBy: "desc",
        orderByName: "periodId",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          breedId: "",
          type: "Y", // Y表示年,M表示按月查询,D表示近日查询
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : Page.getCurrentYear(), // 如果type为Y则year不能为空,如果type不为Y year一定要为null
          startDate: "",
          endDate: "",
          total: false,
          operationTypeId: "", //操作类型
          breedTypeId: "", // 养殖品类
          periodId: "", // 育苗批次
          breedTypeClass: "fish", // fish ：养成 egg：育苗
        },
      };
      this.getBaseList();
    },
    search() {
      this.initPage(this.param);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },
    // 初始化列表
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getCostRecordsListByPages(data)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.pageNo = res.data.pageNumber;
            this.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
          }
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => this.$message.error(err));
    },
    // 育苗-存塘概览报表-实时存塘量
    doExport() {
      console.log("导出方法");
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            titleName: "养成结转成本统计",
            sheetName: "列表",
            fileName: "养成结转成本统计",
            param: this.param,
          };
          const flag = await Page.exportDatas(
            "/outSaleCost/getOutSaleCostExportTable",
            param
          );
        })
        .catch(() => { });
    },
    getFodderMeasureUnit(orgId) {
      // 获取是否公斤转换成斤
      listParamStatus(orgId, ['fodderKgToJin']).then((res) => {
        if (res.code == "0000") {
          this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : '公斤';
        }
      })
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped>
.old-page-list {
  height: calc(~"100% - 90px");
}

.el-pagination {
  margin-top: 20px;
}
</style>



